import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import {
  validateAadhar,
  validatePhoneNumber,
  validateEmail,
} from "../../utils/validation";

const AuthorisedPickUp = ({ formData, setFormData }) => {
  const { id } = useParams(); // Get student ID from the URL
  const [errors, setErrors] = useState([]);

  // Ensure blank row when cleared
  useEffect(() => {
    if (!formData.authorizedpickup || formData.authorizedpickup.length === 0) {
      const blankRow = [{ name: "", relationship: "", Mobile_Number: "", remark: "" }];
      setAuthorisedPickups(blankRow);
      setFormData((prevData) => ({
        ...prevData,
        authorizedpickup: blankRow,
      }));
    } else {
      setAuthorisedPickups(formData.authorizedpickup);
    }
  }, [formData.authorizedpickup, setFormData]);

  // Initialize state based on formData, ensuring formData and authorizedpickup are defined
  const [authorisedPickups, setAuthorisedPickups] = useState(
    formData?.authorizedpickup && formData.authorizedpickup.length > 0
      ? formData.authorizedpickup
      : [{ name: "", relationship: "", Mobile_Number: "", remark: "" }]
  );

  // Fetch authorized pickups details based on student ID
  //   useEffect(() => {
  //     const fetchAuthorizedPickups = async () => {
  //       try {
  //         const response = await fetch(`${ApiUrl.apiurl}
  // STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`);
  //         const data = await response.json();

  //         // Extract authorized_pickup data and set it in formData only if authorized pickups are empty
  //         if (
  //           data?.data?.authorized_pickup &&
  //           !formData?.authorizedpickup?.length
  //         ) {
  //           setAuthorisedPickups(data.data.authorized_pickup);
  //           setFormData((prevData) => ({
  //             ...prevData,
  //             authorizedpickup: data.data.authorized_pickup,
  //           }));
  //         }
  //       } catch (error) {
  //         console.error("Error fetching authorized pickups:", error);
  //       }
  //     };

  //     fetchAuthorizedPickups();
  //   }, [id, formData?.authorizedpickup?.length, setFormData]); // Use optional chaining for safe access

  useEffect(() => {
    const fetchAuthorizedPickups = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
        );
        const data = await response.json();

        // Extract authorized_pickup data and set it in formData only if it's empty
        // if (
        //   data?.data?.authorized_pickup &&
        //   (!formData?.authorizedpickup || formData.authorizedpickup.length === 0)
        // ) {
        //   setAuthorisedPickups(data.data.authorized_pickup);
        //   setFormData((prevData) => ({
        //     ...prevData,
        //     authorizedpickup: data.data.authorized_pickup,
        //   }));
        // }
        if (
          data?.data?.authorized_pickup &&
          (!formData?.authorizedpickup || formData.authorizedpickup.length === 0)
        ) {
          const updatedPickups = data.data.authorized_pickup.map((item) => ({
            ...item,
            isNew: false, // Mark as existing row
          }));
          setAuthorisedPickups(updatedPickups);
          setFormData((prevData) => ({
            ...prevData,
            authorizedpickup: updatedPickups,
          }));
        }

      } catch (error) {
        console.error("Error fetching authorized pickups:", error);
      }
    };

    if (id) {
      fetchAuthorizedPickups();
    }
  }, [id, formData?.authorizedpickup?.length, setFormData]);


  // Function to handle adding a new row with validation
  const handleAddRow = () => {
    const incompletePickups = authorisedPickups.filter(
      (pickup) => !pickup.name || !pickup.relationship || !pickup.Mobile_Number
    );

    if (incompletePickups.length > 0) {
      alert(
        "Please fill in all required fields (Name, Relationship, Mobile No) before adding a new one."
      );
      return;
    }

    setAuthorisedPickups([
      ...authorisedPickups,
      { name: "", relationship: "", Mobile_Number: "", remark: "", isNew: true },
    ]);
  };

  // Function to handle removing a row
  // const handleRemoveRow = (index) => {
  //   const updatedRows = authorisedPickups.filter((_, i) => i !== index);
  //   setAuthorisedPickups(updatedRows);
  //   setFormData({ ...formData, authorizedpickup: updatedRows }); // Update formData
  // };

  //New Code 01082025
  const handleRemoveRow = (index) => {
    if (!authorisedPickups[index].isNew) {
      alert("Only newly added rows can be removed.");
      return;
    }
    const updatedRows = authorisedPickups.filter((_, i) => i !== index);
    setAuthorisedPickups(updatedRows);
    setFormData({ ...formData, authorizedpickup: updatedRows });
  };

  // Function to handle input changes
  const handleInputChange = (index, field, value) => {
    const updatedRows = [...authorisedPickups];

    if (field === "relationship") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    }

    updatedRows[index][field] = value;

    // Validation for Mobile_Number field
    if (field === "Mobile_Number") {
      const updatedErrors = [...errors];

      if (!validatePhoneNumber(value)) {
        updatedErrors[index] = "Phone number must contain only numbers.";
      } else if (value.length < 10) {
        updatedErrors[index] = "Phone number must be exactly 10 digits.";
      } else {
        updatedErrors[index] = ""; // Clear error if valid
      }

      setErrors(updatedErrors); // Update error state
    }

    setAuthorisedPickups(updatedRows);
    setFormData({ ...formData, authorizedpickup: updatedRows }); // Update formData
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>S.No.</th>
            <th>
              Name<span className="red-text">*</span>
            </th>
            <th>
              Relationship<span className="red-text">*</span>
            </th>
            <th>
              Mobile No<span className="red-text">*</span>
            </th>
            <th>Remarks</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {authorisedPickups.map((row, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>
                <input
                  type="text"
                  value={row.name}
                  style={{ textTransform: "none" }}
                  onChange={(e) =>
                    handleInputChange(index, "name", e.target.value)
                  }
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  value={row.relationship}
                  style={{ textTransform: "none" }}
                  onChange={(e) =>
                    handleInputChange(index, "relationship", e.target.value)
                  }
                  required
                />
              </td>
              {/* <td>
                <input
                  type="text"
                  value={row.Mobile_Number}
                  onChange={(e) => handleInputChange(index, 'Mobile_Number', e.target.value)}
                  maxLength={10}
                  required
               
                />
                   {errors[index] && (
                    <span style={{ color: "red", fontSize: "0.8em", marginTop: "4px", display: "block" }}>
                      {errors[index]}
                    </span>
                  )}
              </td> */}

              <td>
                <input
                  type="text"
                  value={row.Mobile_Number}
                  onChange={(e) => {
                    // Restrict input to only digits (0-9)
                    const value = e.target.value.replace(/[^0-9]/g, ""); // This regex removes any non-numeric characters
                    handleInputChange(index, "Mobile_Number", value);
                  }}
                  maxLength={10} // Restrict input to 10 characters
                  required
                />
                {errors[index] && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      marginTop: "4px",
                      display: "block",
                    }}
                  >
                    {errors[index]}
                  </span>
                )}
              </td>

              <td>
                <input
                  type="text"
                  value={row.remark}
                  style={{ textTransform: "none" }}
                  onChange={(e) =>
                    handleInputChange(index, "remark", e.target.value)
                  }
                />
              </td>
              <td>
                <button
                  type="button"
                  className="btn btn-danger add-row"
                  onClick={() => handleRemoveRow(index)}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleAddRow}
        >
          Add New Pickup
        </button>
      </div>
    </div>
  );
};

export default AuthorisedPickUp;
